export enum SIGN_UP_STEPS {
  HOME,
  PHONE_VERIFY,
  PASSWORD,
  USER_INFO_FORM,
}
